import axios from 'axios';
import { AtToastTypes } from '@agritask/vue-components';
import { getTranslators } from '@agritask/vue-components/utils';
import { redirectToLoginPage } from './redirectTo';
export async function axiosGet(url, config) {
    return axios
        .get(url, config)
        .then((response) => response.data)
        .catch((reason) => {
        handlePromiseError(reason);
        console.warn(`GET request failed: ${reason}`);
        throw new Error(reason?.message || reason, { cause: reason });
    });
}
export async function axiosGetFailsWithError(url, config) {
    return axios
        .get(url, config)
        .then((response) => response.data)
        .catch((reason) => {
        handlePromiseError(reason);
        console.warn(`GET request failed: ${reason}`);
        throw reason;
    });
}
export async function axiosPost(url, data, config) {
    return axios
        .post(url, data, config)
        .then((response) => response.data)
        .catch((reason) => {
        handlePromiseError(reason);
        console.warn(`POST request failed: ${reason}`);
        throw reason;
    });
}
export async function axiosDelete(url, payload) {
    return axios
        .delete(url, { data: payload })
        .then((response) => response.data)
        .catch((reason) => {
        handlePromiseError(reason);
        console.warn(`DELETE request failed: ${reason}`);
        throw reason;
    });
}
export async function axiosDynamic(config) {
    return axios(config)
        .then((response) => {
        if (response.headers['content-type'] === 'application/octet-stream') {
            downloadBlob(response);
        }
        return response;
    })
        .then((response) => response.data)
        .catch((reason) => {
        handlePromiseError(reason);
        console.warn(`${config.method?.toUpperCase()} request failed: ${reason}`);
        throw reason;
    });
}
export async function axiosPostWithProgress(url, data, onDownloadProgress) {
    return axios
        .post(url, data, {
        responseType: 'blob',
        onDownloadProgress,
    })
        .catch((reason) => {
        handlePromiseError(reason);
        console.warn(`axiosPostWithProgress request failed: ${reason}`);
        throw reason;
    });
}
export async function axiosGetWithInstance(axiosInstance, url, config) {
    return axiosInstance
        .get(url, config)
        .then((response) => response.data)
        .catch((reason) => {
        //reason.response includes the status and more
        throw reason;
    });
}
export async function axiosPostWithInstance(axiosInstance, url, data, config) {
    return axiosInstance
        .post(url, data, config)
        .then((response) => response.data)
        .catch((reason) => {
        //reason.response includes the status and more
        throw reason;
    });
}
export async function axiosPutWithInstance(axiosInstance, url, data, config) {
    return axiosInstance
        .put(url, data, config)
        .then((response) => response.data)
        .catch((reason) => {
        throw reason;
    });
}
export async function axiosDeleteWithInstance(axiosInstance, url, config) {
    return axiosInstance
        .delete(url, config)
        .then((response) => response.data)
        .catch((reason) => {
        throw reason;
    });
}
export async function axiosDynamicWithInstance(axiosInstance, config) {
    return axiosInstance(config)
        .then((response) => {
        if (response.headers['content-type'] === 'application/octet-stream') {
            downloadBlob(response);
        }
        return response;
    })
        .then((response) => response.data)
        .catch((reason) => {
        console.warn(`${config.method?.toUpperCase()} request failed: ${reason}`);
        throw reason;
    });
}
export function downloadBlob(response) {
    let blob;
    const link = document.createElement('a');
    if (response instanceof Blob) {
        blob = response;
        link.download = 'Attachment';
    }
    else {
        blob = new Blob([response.data], {
            type: 'application/octet-stream',
        });
        link.download = decodeURI(response.headers['content-disposition'].replace('attachment;filename=', ''));
    }
    link.href = window.URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export function handlePromiseError(error, vm, callbackFn) {
    if (error.response?.status === 401) {
        redirectToLoginPage();
    }
    else if (callbackFn) {
        callbackFn();
    }
    else {
        showDefaultErrorToast(vm);
    }
}
export function handleGraphQLPromiseError(error, vm, callbackFn) {
    if (error.message.includes('Received status code 401')) {
        redirectToLoginPage();
    }
    else {
        handlePromiseError(error, vm, callbackFn);
    }
}
function showDefaultErrorToast(vm) {
    const { t } = getTranslators();
    vm?.$atToast.create({
        type: AtToastTypes.AtToastType.Error,
        title: t('errors.default.title', 0),
        message: t('errors.default.description'),
    });
}
